import { useState, useEffect } from 'react';
import ICAL from 'ical.js';
import { apiFetch } from '../api';

function StatsPanel({ refreshKey, bookingData }) {
  const [stats, setStats] = useState(null);
  const [airbnbYtd, setAirbnbYtd] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchStats(); }, [refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { calcAirbnbYtd(); }, [refreshKey, bookingData]); // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchStats() {
    try {
      const res = await apiFetch('/api/stats');
      if (res.ok) setStats(await res.json());
    } catch {}
    finally { setLoading(false); }
  }

  async function calcAirbnbYtd() {
    try {
      const res = await apiFetch('/api/calendar/airbnb');
      const text = await res.text();
      const parsed = ICAL.parse(text);
      const comp = new ICAL.Component(parsed);
      const vevents = comp.getAllSubcomponents('vevent');
      const currentYear = new Date().getFullYear();

      let total = 0;
      for (const ve of vevents) {
        const event = new ICAL.Event(ve);
        const summary = event.summary || '';
        if (summary === 'Airbnb (Not available)') continue;
        const uid = event.uid || '';
        const amount = Number(bookingData[uid]?.amount || 0);
        if (!amount) continue;
        const checkIn = event.startDate.toJSDate();
        const checkOut = event.endDate.toJSDate();
        const nights = Math.round((checkOut - checkIn) / (1000 * 60 * 60 * 24));
        if (nights <= 0) continue;
        const perNight = amount / nights;
        const d = new Date(checkIn);
        while (d < checkOut) {
          if (d.getFullYear() === currentYear) total += perNight;
          d.setDate(d.getDate() + 1);
        }
      }
      setAirbnbYtd(total);
    } catch (err) {
      console.error('Stats: Airbnb YTD calc failed', err);
    }
  }

  if (loading || !stats) return <section className="card"><h2>Stats</h2><p className="loading">Loading...</p></section>;

  const airbnbK = Math.round(airbnbYtd / 1000 * 10) / 10;

  const kpis = [
    { value: `$${stats.culversFundingThousands}K`, label: "Culver's Funding" },
    { value: `${stats.netWorthMillions.toFixed(2)}`, label: '' },
    { value: `$${airbnbK}K`, label: 'Airbnb YTD' },
  ];

  return (
    <section className="card stats-panel">
      <h2>Stats</h2>
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', justifyContent: 'center' }}>
        {kpis.map((kpi, i) => (
          <div key={i} style={{ textAlign: 'center', flex: '1 1 80px', minWidth: 80 }}>
            <div style={{ fontSize: 36, fontWeight: 700, color: '#e4e4e7' }}>{kpi.value}</div>
            {kpi.label && <div style={{ fontSize: 13, color: '#71717a', marginTop: 2 }}>{kpi.label}</div>}
          </div>
        ))}
      </div>
    </section>
  );
}

export default StatsPanel;
